<template>
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <g stroke="#000000" stroke-width="2">
      <path d="M16 16V8a1 1 0 00-1-1H5a1 1 0 00-1 1v8a1 1 0 001 1h10a1 1 0 001-1z" />
      <path stroke-linejoin="round" d="M20 7l-4 3v4l4 3V7z" />
    </g>
  </svg>
</template>
